import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Preload() {
  // Critical fonts
  const criticalFonts = [
    '/fonts/plus-jakarta-sans-regular.woff2',
    '/fonts/plus-jakarta-sans-semibold.woff2',
  ];

  // Critical images (e.g., logo, hero background)
  const criticalImages = [
    '/images/Logo.png',
    '/images/Modular Kitchen 01.jpg',
  ];

  return (
    <Helmet>
      {/* Preload critical fonts */}
      {criticalFonts.map((font) => (
        <link
          key={font}
          rel="preload"
          href={font}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
      ))}

      {/* Preload critical images */}
      {criticalImages.map((image) => (
        <link
          key={image}
          rel="preload"
          href={image}
          as="image"
        />
      ))}
    </Helmet>
  );
}